import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppcontractStepPaymentEditComponent } from '../contract-step-payment-edit/contract-step-payment-edit.component';
import { catchError, EMPTY, filter, Subscription, switchMap, tap } from 'rxjs';
import { IMultiPaymentStateCS, TPaymentData } from '../../../../models/finance.model';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractDataService } from '../../services/contract-data.service';
import { ContractAvatarsService } from '../../services/contract-avatar.service';
import { AVATARS_MOCK } from '../../models/fotos';
import { DialogsMTService } from '../../../../services/modal/dialogs-mt.service';
import { FinanceService } from '../../../../services/api/finance.service';
import { AlertService } from '../../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ContractFormService } from '../../services/contract-form.service';
import { AppContractStepPaymentViewComponent } from '../contract-step-payment-view/contract-step-payment-view.component';
@Component({
    selector: 'app-contract-step-multipayment',
    templateUrl: './contract-step-multi-payment.component.html',
    styleUrl: './contract-step-multi-payment.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepMultiPaymentComponent {
    private subs = new Subscription()
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    public multiPayment!:FormGroup
    public avatarsMocks = AVATARS_MOCK
    public stepTartget: IMultiPaymentStateCS|null = null
    public signedPayments:string[] = []
    public membersSignedPayment:string[] = []
    constructor(
      private fb: FormBuilder,
      private dialog:MatDialog ,
      private translateService:TranslateService ,
      private contractFormService:ContractFormService ,
      private dialogsMTService:DialogsMTService ,
      private alertService:AlertService ,
      private financeService:FinanceService ,
      public contractDataService:ContractDataService,
      public contractAvatarsService:ContractAvatarsService,
      private cds:ChangeDetectorRef
    ) {
        this.multiPayment = this.fb.group({
          payment: ['',Validators.required], 
        });
     }
    ngOnDestroy(): void {
    this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.subs.add(this.contractDataService.subContractDetectChanges.subscribe(()=>this.cds.detectChanges()))
      this.stepTartget = this.contractDataService.getCachedStepTargetData(this.contractStep) as IMultiPaymentStateCS
      this.signedPayments = this.stepTartget.paymentsData.map(pmt=>pmt.members.map(mem=>mem.signed_payment_guid +'_'+ mem.contract_member.member.guid)).flat()
      this.membersSignedPayment = this.stepTartget.paymentsData.map(pmt=>pmt.members.map(mem=>mem.contract_member.member.guid)).flat()
      this.contractStep = {...this.contractStep!,  payment_data:null}
      let firstOpt = this.contractStep?.multi_payment_data
      firstOpt?.length && this.payment? this.payment.patchValue(firstOpt[0]?.payment_guid) :  null
    }
    viewPayment(paymentGuid:string) {
      let targetData = this.stepTartget?.paymentsData.find(el=>el.payment.guid === paymentGuid)
      this.contractStep!.payment_data = this.contractStep?.multi_payment_data?.find(el=>el.payment_guid===paymentGuid)
      if (this.contractStep?.target_key&&this.contractStep.payment_data) {
        let paymentViweRef = this.dialog.open(AppContractStepPaymentViewComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'468px',
          height:'520px'
        })
        paymentViweRef.componentInstance.paymentGuid = this.contractStep?.target_key 
        paymentViweRef.componentInstance.paymentStep = this.contractStep 
        paymentViweRef.componentInstance.targetData = targetData?.payment 
        paymentViweRef.componentInstance.contractParties = this.contractData?.contract?.projects!

      }
    }
    editPayment (paymentGuid:string,item:any){
      if (this.contractData?.rights?.isContractBlockedForEdit === true) {
        return
      }
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractStep!.payment_data = this.contractStep?.multi_payment_data?.find(el=>el.payment_guid===paymentGuid)
        let paymentEditRef = this.dialog.open(AppcontractStepPaymentEditComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'412px',
          height:'380px'
        })
        paymentEditRef.componentInstance.contractParties = this.contractData?.contract?.projects!
        paymentEditRef.componentInstance.contractStep = this.contractStep!
      })
    }
    addPayment(){
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        this.contractStep?.multi_payment_data? null: this.contractStep!.multi_payment_data = [];
        let newPayment:TPaymentData = {
          payer_guid:'',
          payer_type:undefined,
          recipient_guid:'',
          recipient_type:undefined,
          total:'',
          payment_guid:'new_payment_' + this.contractStep?.multi_payment_data.length,
        }
        this.contractStep!.payment_data = newPayment
        let paymentEditRef = this.dialog.open(AppcontractStepPaymentEditComponent,{
          panelClass:'payment-edit-dialog-box',
          width:'412px',
          height:'380px'
        })
        paymentEditRef.componentInstance.contractParties = this.contractData?.contract?.projects!
        paymentEditRef.componentInstance.contractStep = this.contractStep!
        paymentEditRef.componentInstance.paymentCreate = true
      })
    }
    deletePayment(paymentGuid:string){
      if (this.contractData?.rights?.isContractBlockedForEdit === true) {
        return
      }
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        let deletedIndex = this.contractStep?.multi_payment_data?.findIndex(el=>el.payment_guid === paymentGuid)
        this.contractStep?.multi_payment_data?.splice(deletedIndex!,1)
        let payments = this.contractDataService.getCachedStepTargetData(this.contractStep!)  as IMultiPaymentStateCS 
        payments.paymentsData = payments.paymentsData.filter((el:any)=>el.payment.guid !== paymentGuid);
        this.contractDataService.subContractEdited.next(true)
        this.contractDataService.subContractDetectChanges.next(true)
      })
    }
    signOnOffPayment() {
      this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(()=>{
        let userGuid = this.contractDataService.currentMember?.guid
        this.formState = 'Submitting'
        let isPaymentSighned = this.signedPayments.includes((this.payment?.value||'') + '_'+ userGuid)
        if (!this.contractStep?.guid || !this.payment?.value) { return }
        let pinMessage = this.translateService.instant(isPaymentSighned ? 'MODALS.HEADERS.RECALL_PAYMENT' : 'MODALS.HEADERS.SIGN_PAYMENT' );

        this.dialogsMTService.openPinDialog(!isPaymentSighned,pinMessage)
        .pipe(
          tap(res=>res.pin == null? this.changeState('Default') :null),
          filter(res => res.pin !== null),
          switchMap(res=> isPaymentSighned? 
            this.financeService.terminatePayment(this.contractStep?.target_key!,this.payment?.value,res.pin.toString())
            :this.financeService.signPayment(this.contractStep?.target_key!,this.payment?.value,res.pin.toString()) 
          ),
          (catchError(e=>{
            this.alertService.setAlert(e.message,'blue')
            this.changeState('Default')
            return EMPTY
          })))
        .subscribe(data=>{
          let userAvatar = this.contractStep?.membersAvatarsToShow?.find(el=>el.guid === userGuid)
          userAvatar? userAvatar.state = !userAvatar.state : null
          this.stepTartget? this.stepTartget.isMemberSign = !this.stepTartget?.isMemberSign : null
          if (isPaymentSighned) {
            let pmtInd = this.signedPayments.findIndex(el=>el === (this.payment?.value||'') + '_'+ userGuid) 
            this.signedPayments.splice(pmtInd,1)
            let userInd = this.membersSignedPayment.findIndex(el=>el===userGuid!)
            this.membersSignedPayment.splice(userInd,1)
          } else {
            this.signedPayments.push((this.payment?.value||'') +'_'+  userGuid)
            this.membersSignedPayment.push(userGuid!)
          }
          if (this.signedPayments[0])  {
              this.stepTartget!.isSignPaymentsALot = this.signedPayments.filter(el=>el.split('_')===this.signedPayments[0].split('_')).length === this.contractData?.allSignatoriesInContract.length
            }
          this.contractDataService.subStepDataChanged.next({
            step:this.contractStep!,
            stepName:this.contractStep!.name||this.contractStep!.auto_name||''
          })
          this.alertService.setAlert(data.message,'nd_color')
          this.changeState('Default')
        })
      })
    }
    changeState(state:TFormState) {
      this.formState = state
      this.cds.detectChanges()
    }
    get payment () {
      return this.multiPayment.get('payment')
    }
}


